import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-mist" data-id="element-79" data-mp="38nc9rfhv2c49">
      <div className="max-w-5xl mx-auto" data-id="element-80" data-mp="3dl5fk7f95440">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-ink text-center mb-12 uppercase" data-id="element-81" data-mp="3dm6w2rf1eit4">
          Everything Included in <span className="text-forest" data-id="element-82" data-mp="3mladzs2gws61">Workplace Safety Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-83" data-mp="xsyeby3iglpn">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-forest border-b-4 border-gold rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-84" data-mp="11ts3eusow6k4">
              <Icon size={28} className="text-gold-light" aria-hidden="true" data-id="element-85" data-mp="1i7ge4ytcmg8r" />
              <span className="text-white font-display font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-86" data-mp="1dbiwmp6cn3ue">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-87" data-mp="149rqxkbt6x0j">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-line rounded-xl p-4 flex items-center gap-3" data-id="element-88" data-mp="ujq5l0aubspb">
              <span className="w-9 h-9 rounded-lg bg-forest-50 text-forest flex items-center justify-center shrink-0" data-id="element-89" data-mp="plew4qogjk7m">
                <Icon size={18} aria-hidden="true" data-id="element-90" data-mp="kk7m0kyue8xs" />
              </span>
              <span className="text-ink font-bold text-xs uppercase leading-tight" data-id="element-91" data-mp="gjxkbki324oq">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-gold rounded-3xl p-8 md:p-12 shadow-xl shadow-ink/10 text-center" data-id="element-92" data-mp="1xrs85fuuxi4">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-93" data-mp="3t54a6mokbez3" />
          <p className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-ink mb-1" data-id="element-94" data-mp="pn2w3vsi580h">
            WORKPLACE SAFETY <span className="text-forest" data-id="element-95" data-mp="axeuetges7c8">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-forest mb-3" data-id="element-96" data-mp="fxj9qg5kyw0v">
            The Complete 6-IN-1 Visual Training System for Workplace Safety Instructors
          </p>
          <p className="text-base text-graphite/80 max-w-2xl mx-auto mb-8" data-id="element-97" data-mp="13lsqh3nxstl5">
            A complete professional visual training system created to help workplace safety
            instructors prepare lessons, explain industrial hazards, organize training sessions and
            assess student understanding with greater clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-ink mb-1" data-id="element-98" data-mp="31v9hpgqs1plc">YOUR PRICE:</p>
          <p className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gold mb-6" data-id="element-99" data-mp="2xupo2n5ex43y">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-100" data-mp="2a7hhm1w8zp0c">
            GET THE COMPLETE 6-IN-1 WORKPLACE SAFETY ATLAS NOW!
          </Button>
          <p className="text-xs text-graphite/60 mb-10" data-id="element-101" data-mp="2e6p5nw4p3nbf">
            Immediate Access · 6 Professional Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-line" data-id="element-102" data-mp="3un1k1aa3b56z">
            <p className="font-display text-2xl md:text-3xl font-bold tracking-tight text-ink mb-2 uppercase" data-id="element-103" data-mp="3pl3ww4ykjq8r">
              Stop Preparing Every Workplace Safety Training Session From Scratch.
            </p>
            <p className="text-lg font-semibold text-gold-dark" data-id="element-104" data-mp="tqj0unbfvuul">
              OPEN IT. SHOW IT. EXPLAIN IT. TEACH IT.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}